import { render, staticRenderFns } from "./UserSitesIframe.vue?vue&type=template&id=21083452&scoped=true"
import script from "./UserSitesIframe.vue?vue&type=script&lang=js"
export * from "./UserSitesIframe.vue?vue&type=script&lang=js"
import style0 from "./UserSitesIframe.vue?vue&type=style&index=0&id=21083452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21083452",
  null
  
)

export default component.exports